<a (click)="onClick()" class="app-hyperlink" [class]="cssClass">{{ text }}</a>
